import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../store';
import {
	selectOlivioDesign,
	selectOlivioDesignIsFloracion,
	selectOlivioHousingColourInlay,
	selectOlivioHousingColourInlayIsSatisfied,
	selectOlivioHousingColourPole,
	selectOlivioHousingColourPoleIsSatisfied,
	selectOlivioPoleMaterial,
	selectOlivioPoleMaterialIsSatisfied
} from '../olivioSelectors';
import {
	olivioPoleMaterialOptions,
} from '../olivioModel';
import {spcValueSelectorFactory} from '../../selectors';

@customElement('olivio-general-materials-settings')
export class OlivioGeneralMaterialsSettings extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				display: flex;
				break-inside: avoid;
				flex-flow: column;
				place-content: flex-start;
				gap: var(--small-padding);
			}

			.box {
				background-color: var(--color-widget-background);
				padding: 12px;
				display: flex;
				break-inside: avoid;
				flex-flow: column;
				place-content: flex-start;
				gap: var(--large-space);
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.system = selectOlivioDesign(state);
	}

	render() {
		return html`
			<div class="box">
				<list-select
					.title=${{de: 'Mastmaterial', en: 'Pole Material', fr: 'Pole Material'}}
					.options=${olivioPoleMaterialOptions}
					action='olivio/setPoleMaterial'
					.selected=${selectOlivioPoleMaterial}
					.canBeSelected=${() => true}
					.isSatisfied=${selectOlivioPoleMaterialIsSatisfied}>
				</list-select>

				<spc-attribute .attributeId=${{localId: 'LE_ReflectorColour_1'}} .hideDisabled=${true}></spc-attribute>

				<spc-attribute .attributeId=${{localId: 'HS_HousingColour'}} .hideDisabled=${true}></spc-attribute>

				${when(selectOlivioDesignIsFloracion(this.state), () => html`
					<color-select
						.title=${{de: 'Gehäusefarbe Inlay', en: 'housing colour inlay', fr: 'finition inlay'}}
						.options=${spcValueSelectorFactory('HS_HousingColour')(this.state)}
						action='olivio/setHousingColourInlay'
						.selected=${selectOlivioHousingColourInlay}
						.canBeSelected=${() => true}
						.isSatisfied=${selectOlivioHousingColourInlayIsSatisfied}>
					</color-select>
					<color-select
						.title=${{de: 'Gehäusefarbe Mast', en: 'housing colour pole', fr: 'finition pole'}}
						.options=${spcValueSelectorFactory('HS_HousingColour')(this.state)}
						action='olivio/setHousingColourPole'
						.selected=${selectOlivioHousingColourPole}
						.canBeSelected=${() => true}
						.isSatisfied=${selectOlivioHousingColourPoleIsSatisfied}>
					</color-select>
				`)}
			</div>

		`;
	}
}
